import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-receipt-payment-header',
  templateUrl: './receipt-payment-header.component.html',
  styleUrls: ['./receipt-payment-header.component.scss']
})
export class ReceiptPaymentHeaderComponent implements OnInit {


  @Input() pageHeading: string;
  isShowDivIf = false;
  isGraph = false;
  ismonthly = false;
  isgrapandData = false;
  isdatewise = false;

  @Output() toggleDisplayDivIf: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  @Output() togglegraphIf: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  @Output() togglegraphDataIf: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  @Output() printPDF: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  @Output() openPDF: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  @Output() exportexcel: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  constructor() { }

  ngOnInit(): void {
  }

  toggleDisplayDiv(event: MouseEvent) {
    this.isShowDivIf = !this.isShowDivIf;
  }

  public onButtonClick(event: MouseEvent): void {
    this.isgrapandData = !this.isgrapandData;
  }

  togglegraph() {
    this.isGraph = !this.isGraph;
  }

  togglegraphData() {
    this.isgrapandData = !this.isgrapandData;
  }
  togglemonthely() {
    this.ismonthly = !this.ismonthly;
  }

}
